module.exports = __webpack_public_path__ + "img/tab_video_select_icon.09ef3e7f.svg";